import { Button } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import constants from '../../../constants';
import ContentConstants from '../../../contentConstants';
import { ISurveyPreviewModel, SurveyStep } from '../../../models';
import { IApplicationState } from '../../../store';
import { SurveyPreviewActionCreators } from '../../../store/SurveyPreviewActionCreators';
import { assertNonNullable } from '../../../utilities/assertions';
import { HeaderButtonContainer } from '../../common';
import { SurveyNoteHeaderContainer } from '../../notes/SurveyNoteHeaderContainer';

export const SurveyPreview = () => {
	const { publishing, previewItems } = useSelector((storeState: IApplicationState) => storeState.confirmSchedule);
	const { surveyId } = useSelector((storeState: IApplicationState) => storeState.surveyBuilder);
	const { clientId } = useSelector((storeState: IApplicationState) => storeState.survey.surveyEditModel.survey);

	const dispatch = useDispatch();

	if (!previewItems) return null;

	const surveyPreviewModel = previewItems.length > 0 ? (previewItems[0].value as ISurveyPreviewModel) : undefined;
	const disabled = !surveyPreviewModel || !surveyPreviewModel.canPreviewSurvey || clientId === constants.SYSTEM_CLIENT_ID || publishing;

	return (
		<HeaderButtonContainer>
			<SurveyNoteHeaderContainer withoutContainer />
			<Button id='PreviewSurvey' size='md' color='primary' disabled={disabled} onClick={previewSurvey}>
				{ContentConstants.CONFIRMSCHEDULE_BUTTON_PREVIEWSURVEY}
			</Button>
		</HeaderButtonContainer>
	);

	function previewSurvey() {
		assertNonNullable(surveyPreviewModel);
		if (
			surveyPreviewModel.currentStep !== SurveyStep.Complete ||
			(surveyPreviewModel.currentStep === SurveyStep.Complete && !surveyPreviewModel.previewUrl)
		) {
			dispatch(SurveyPreviewActionCreators.PublishPreview(surveyId));
		} else {
			dispatch(SurveyPreviewActionCreators.PreviewSurvey(surveyPreviewModel.previewUrl));
		}
	}
};
